export const useDialogState = (
  initialVisibility?: boolean
) => {
  const isOpen = ref(initialVisibility ?? false)

  const showDialog = () => {
    isOpen.value = true
  }

  const hideDialog = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    showDialog,
    hideDialog,
  }
}
